import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Image from '../../../../Core/Image';

export const SpendingContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0.5rem 1rem;
  height: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 4rem 2.75rem;
  }
`;

export const StyledImage = styled(Image)`
  width: 1.75rem;
  height: 1.75rem;
  margin-right: 1rem;
`;

export const Icon = styled.img`
  width: 1.4rem;
  height: 1.4rem;
  margin-right: 1rem;
`;

export const SlidersContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  ul {
    margin: 0;
    width: 100%;

    li {
      padding: 1rem 0;
      display: block;
      position: relative;

      &:first-child {
        padding-top: 0;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 0;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        padding: 0.75rem 0;
        flex-wrap: nowrap;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        padding: 1rem 0;
      }

      & > div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 60%;

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          width: 30%;
        }

        &:last-child {
          margin-right: 0;
          width: 95%;

          @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
            width: 50%;
          }

          @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
            width: 55%;
          }
        }

        button {
          &:not(.sliderValueLabel) {
            margin: 0;

            @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
              width: 1rem;
              height: 1rem;
              font-size: 0.75rem;
            }
          }
        }
      }
    }
  }

  p {
    font-size: 1.125rem;
    line-height: 1.25rem;
    margin-right: 0.5rem;
    flex: 1 0 auto;
    width: 50%;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 100%;
    }
  }

  .inputSliderContainer {
    max-width: none;
    margin-top: 0.75rem;
    margin-left: 1rem;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-top: 0;
      margin-left: 0;
    }

    .inputRange {
      margin: 0;

      .track {
        margin-top: -1px;
        height: 3px;
        left: 0.25rem;
        right: 0.25rem;

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          margin-top: -0.15rem;
          height: 6px;
          left: 0;
          right: 0;
        }

        .activeTrack {
          margin-top: -1px;
          height: 3px;

          @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
            margin-top: -3px;
            height: 6px;
          }
        }

        .slider {
          width: 1.125rem;
          height: 1.125rem;

          @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
            margin-top: -0.5rem;
            margin-left: -0.5rem;
          }

          @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
            height: 1.5rem;
            width: 1.5rem;
            margin-top: -0.625rem;
            margin-left: -0.75rem;
          }
        }
      }
    }

    .sliderValueLabel {
      font-size: 1.125rem;
      line-height: 1.25rem;
      margin-left: 1rem;
      max-width: 6rem;
      padding: 0;
      top: -3rem;

      @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
        font-size: 1.5rem;
        line-height: 1.75rem;
      }

      @media only screen and (min-width: 658px) {
        position: absolute;
        right: 0;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        font-size: 1.25rem;
        line-height: 1.5rem;
        margin-right: 0;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        font-size: 1.5rem;
        line-height: 1.75rem;
        max-width: 6.5rem;
        position: relative;
        top: auto;

        &:lang(fr) {
          max-width: 90px;
        }
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 1.75rem;
        line-height: 1.75rem;
        margin-left: 1.5rem;

        &:lang(fr) {
          max-width: 100px;
        }
      }
    }
  }
`;

export const PurchaseTotalContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    position: absolute;
    bottom: 0;
  }
`;

export const PurchaseText = styled.div`
  font-weight: ${themeGet('fontWeights.medium')};
  font-size: 1.5625rem;
  line-height: 1.25rem;
`;

export const PurchaseTotal = styled.div`
  color: ${themeGet('colors.secondary-velvet')};
  font-size: 1.75rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: normal;
  margin-right: 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-right: 0;
  }
`;

export const Legend = styled.p`
  font-size: 1rem;
  text-align: right;
  margin-bottom: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: none;
  }
`;
